// Constants
import { EMPTY_OBJECT } from '../../app.constants'; // Readers

import setupFieldsReader from '../../readers/SetupField';

var getSetupFieldsLabel = function getSetupFieldsLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var defaultCode = setupFieldsReader.code(option);
  var defaultName = setupFieldsReader.name(option);

  if (defaultCode && defaultName) {
    return "".concat(defaultCode, " - ").concat(defaultName);
  }

  return undefined;
};

export default getSetupFieldsLabel;